/**
 * Admin — Placeholder page for modules under construction.
 */

import React from 'react';
import styles from './AdminPages.module.css';

interface Props {
  title: string;
  description: string;
  features?: string[];
}

export default function AdminPlaceholder({ title, description, features }: Props) {
  return (
    <div>
      <h1 className={styles.pageTitle}>{title}</h1>
      <p className={styles.pageSubtitle}>{description}</p>

      <div className={styles.placeholderBox}>
        <div className={styles.placeholderIcon}>&#9881;</div>
        <p className={styles.placeholderText}>This module is under development.</p>
        {features && features.length > 0 && (
          <div className={styles.placeholderFeatures}>
            <strong>Planned capabilities:</strong>
            <ul>
              {features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
